import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";

import type { OrderLineVideo, OrderScriptRow } from "../types/marketplace.types";

/** Ops status editor shows the persisted line status, not video rollup. */
export function opsScriptStatusMenuValue(
  script: OrderScriptRow,
): MarketplaceFulfillmentStatus {
  return script.fulfillmentStatus;
}

/** Per-video ops menu: hydrated fulfillment label when present, else derived. */
export function opsVideoStatusMenuValue(
  script: OrderScriptRow,
  video: Pick<
    OrderLineVideo,
    | "reviewStatus"
    | "revisionNote"
    | "fulfillmentStatus"
    | "isEmpty"
    | "preflightUploadId"
    | "scriptReviewId"
    | "id"
    | "position"
  >,
): MarketplaceFulfillmentStatus {
  if (video.fulfillmentStatus) {
    return video.fulfillmentStatus;
  }
  if (video.reviewStatus === "REVISION_REQUESTED" || video.revisionNote?.trim()) {
    return "SENT_FOR_REVISION";
  }
  return script.fulfillmentStatus;
}
